export default __webpack_public_path__ + "static/media/DieselEconomy.49cdc942.svg";